enum TypeOfNotifications {
  SUCCESS = 1,
  ERROR = 2,
  WARNING = 3,
  INFO = 4,
  BLOCK = 5
}

export { TypeOfNotifications }